import { Combobox } from '@headlessui/react';
import React from 'react';

type SearchboxOptionProps<TValue> = {
    ariaLabel?: string;
    children?: React.ReactNode | SearchboxOptionRenderProp;
    className?: string;
    value: TValue;
};

type SearchboxOptionRenderProp = (args: {
    active: boolean;
    disabled: boolean;
    selected: boolean;
}) => JSX.Element;

export function SearchboxOption<TValue>(props: SearchboxOptionProps<TValue>) {
    const { ariaLabel, children, className = '', value } = props;

    const hasRenderProp = typeof children === 'function';
    const activeClass = hasRenderProp ? '' : 's-bg-info-selected';

    return (
        <Combobox.Option value={value} as={React.Fragment}>
            {({ active, disabled, selected }) => (
                <li
                    aria-label={ariaLabel}
                    className={`block cursor-pointer ${className} ${
                        active ? activeClass : ''
                    }`}
                >
                    {hasRenderProp
                        ? children({ active, disabled, selected })
                        : children}
                </li>
            )}
        </Combobox.Option>
    );
}
